"use client";
import { getClientCookie } from "@lib/cookies.client";

export const getPlatform = (): string | undefined => {
    return getClientCookie("webview") ? getClientCookie("webview") : getClientCookie("source");
};

export const inApp = (): boolean => {
  const platform = getPlatform();
  return (
    platform === "ios_app" ||
    platform === "android_app" ||
    platform === "ackodrive_ios_app" ||
    platform === "ackodrive_android_app"
  );
}; 